import React from 'react';
import { Tappable } from '@vectord/components';
import classnames from 'classnames';

export default function UploadVideoButton({
  children,
  classname,
  onClick,
  isDisabled,
}) {
  return (
    <Tappable
      className={classnames('btn btn-primary', classname)}
      onClick={onClick}
      disabled={isDisabled}
    >
      {children}
    </Tappable>
  );
}
